(() => {
  let pending = Promise.resolve(), revision = 0;
  class PeriplusOrderCart extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('script');
      if (!input) return;
      let attributes;
      try { attributes = JSON.parse(input.textContent); } catch { return; }
      const current = ++revision;
      pending = pending.catch(() => {}).then(async () => {
        if (current !== revision || !this.isConnected || !Object.keys(attributes).length) return;
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes }), keepalive: true
        });
        if (!response.ok) throw new Error('Preparation snapshot was not saved');
        this.dataset.saved = 'true';
      }).catch(() => { this.dataset.saved = 'false'; });
    }
  }
  if (!customElements.get('periplus-order-cart')) customElements.define('periplus-order-cart', PeriplusOrderCart);
})();
